import { SPECIALTIES } from './data/specialties.data';

export type SiteDataState = 'loading' | 'ready' | 'fallback';

export const DOCTOR_SLUG_PREFIX = 'dr-';
export const DEPARTMENT_SLUG_PREFIX = 'dept-';

export const GIVE_UP_MS = 8000;

export function normalizeName(value: string): string {
  return (value || '').toLowerCase().replace(/[^a-z]/g, '');
}

export function departmentSlugOf(departmentId: string, departmentName: string): string {
  const specialty = SPECIALTIES.find(s => normalizeName(s.name) === normalizeName(departmentName));
  return specialty ? specialty.slug : DEPARTMENT_SLUG_PREFIX + departmentId;
}
